<template>
  <section class="forgot-password-wrapper">
    <forgot-form />
  </section>
</template>
<script>

export default {
  components: {
    ForgotForm: () => import(/* webpackChunkName: "forgot"  */ `./ForgotForm`),
  },
}
</script>
<style lang="scss" scoped>

.forgot-password-wrapper {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 20px 15px 15px 15px;
  width: 100%;

  @include teq-breakpoint($large) {
    max-width: calc(100% - 186px);
  }
}
</style>
